import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AgeRestrictionCode, AgeRestrictionViolation } from '../../../../../models/age-restriction';


let nextInputId = 0;

/** The inline age-band warning and bypass acknowledgement of the invite and add-to-waitlist modals (PRO-1558). */
@Component({
  selector: 'app-age-restriction-bypass-warning',
  templateUrl: './age-restriction-bypass-warning.component.html',
})
export class AgeRestrictionBypassWarningComponent {
  public readonly AgeRestrictionCode = AgeRestrictionCode;
  public readonly inputId = 'ageRestrictionBypass' + (nextInputId++).toString();

  @Input() violations: AgeRestrictionViolation[] = [];
  // False for an event type waitlist, where there is no event to measure at.
  @Input() atEventStart = true;
  @Input() disabled = false;

  @Input() acknowledged = false;
  @Output() acknowledgedChange = new EventEmitter<boolean>();

  public participantCount(): number {
    return new Set(this.violations.map(row => row.participantKey)).size;
  }

  public setAcknowledged(acknowledged: boolean) {
    this.acknowledged = acknowledged;
    this.acknowledgedChange.emit(acknowledged);
  }
}
